import { render, staticRenderFns } from "./infoPreferences.vue?vue&type=template&id=1617bd98&"
import script from "./infoPreferences.vue?vue&type=script&lang=js&"
export * from "./infoPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports